import * as React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  rightElement?: React.ReactNode;
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, icon, rightElement, error, ...props }, ref) => {
    return (
      <div className="relative w-full group">
        {icon && (
          <div
            className={cn(
              'absolute z-1 start-4 top-1/2 -translate-y-1/2 transition-colors pointer-events-none',
              error ? 'text-destructive' : 'text-muted-foreground group-focus-within:text-primary'
            )}
          >
            {icon}
          </div>
        )}
        <input
          type={type}
          className={cn(
            'flex h-11 w-full rounded-2xl border-2 border-border bg-background text-foreground px-4 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground/85 placeholder:opacity-100 focus-visible:outline-none focus-visible:border-primary focus-visible:shadow-lg focus-visible:shadow-primary/10 disabled:cursor-not-allowed disabled:opacity-50 transition-all dark:[color-scheme:dark]',
            (type === 'date' || type === 'time' || type === 'datetime-local') &&
              'pe-12 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:end-4 [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-60 hover:[&::-webkit-calendar-picker-indicator]:opacity-100',
            icon && 'ps-12',
            rightElement && 'pe-12',
            error && 'border-destructive focus-visible:border-destructive',
            className
          )}
          ref={ref}
          {...props}
        />
        {rightElement && (
          <div className="absolute end-4 top-0 h-full flex items-center justify-center">
            {rightElement}
          </div>
        )}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
